// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ntPLhJVlFLsatf06{display:flex;flex-direction:row;background-color:var(--py-primary-1);padding:20px;border-radius:2px;margin-bottom:20px;width:400px;margin-right:10px}.ntPLhJVlFLsatf06 div:nth-child(2){font-weight:600}.ntPLhJVlFLsatf06 .BQsOYqCsDgo0jZcj{margin-right:6px;font-size:18px;color:var(--py-primary-7)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBox": `ntPLhJVlFLsatf06`,
	"infoIcon": `BQsOYqCsDgo0jZcj`
};
export default ___CSS_LOADER_EXPORT___;
